import { ThemeProvider } from '@mui/material/styles';
import { appTheme } from './themes/app-theme';
import { PropsWithChildren } from 'react';
// GENERAL STYLE
import './themes/app-style.scss'; // last to override other styling

export const AppThemeProvider = ({ children }: PropsWithChildren<{}>) => {
  return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};
